export default "__VITE_ASSET__SQO2oOsd__"